module.exports = __webpack_public_path__ + "warning_16px.png?0531513e4a75aae0448d0ccd496cde50";